import * as React from "react";
import Merchant from '../common/Merchant'

export interface SettingsInfoProps {
  merchants: Array<Merchant>
}

interface State {
  selectedAccount?: string;
  selectedChargeType?: string;
  selectedMerchant?: Merchant;
}

class SettingsInfo extends React.Component<SettingsInfoProps, State> {
  public constructor(props: SettingsInfoProps) {
    super(props);
    this.state = { selectedChargeType: 'creditcard'};
  }

  private merchantForId = (id: string)=>{
    return this.props.merchants.find(el => el.id == id)
  };

  private selectAccount = (e: React.ChangeEvent<HTMLSelectElement>) => {
    this.setState({ selectedAccount: e.target.value })
  };

  private selectChargeType = (e: React.ChangeEvent<HTMLSelectElement>) => {
    this.setState({ selectedChargeType: e.target.value })
  };

  public render() {
    if (this.props.merchants.length <= 0) {
      return (
        <div className="section side">
          <h1>Start Collecting Payments</h1>
          <h2>Get Started using the Affinipay Plugin Now.</h2>
        </div>
      );
    }

    const selected = this.state.selectedAccount || this.props.merchants[0].id;
    const selectedChargeType = this.state.selectedChargeType
    const selectedMerchant = this.merchantForId(selected);

    return (
      <div className="section side">
        <h3>Start Collecting Payments</h3>
        Account:<select onChange={this.selectAccount}>
          {this.props.merchants.map((merchant, i) => (
            <option value={merchant.id} key={i}>
              {merchant.name} {merchant.trust_account && "- Trust"}
              {merchant.status !== 'ACTIVE' && `(${merchant.status})`}
              </option>
          ))}
        </select>
        Charge Type:<select onChange={this.selectChargeType}>
            <option value={'creditcard'} key={0}>Credit Card</option>
            <option value={'echeck'} key={1}>eCheck</option>
        </select>
        <p>
          Add the following shortcode to the content area on any page to display
          the payment form.
        </p>
        <textarea onClick={e => e.currentTarget.select()} value={`[affinipay-payment type=${selectedChargeType} account=${selected}]`} readOnly={true}/>
        {(selectedMerchant && selectedMerchant.status !== 'ACTIVE') &&
      <span className={"warning"}>
          Note: This account is not active
      </span>
        }
      </div>
    );
  }
}

export default SettingsInfo;



// WEBPACK FOOTER //
// ./src/settings/SettingsInfo.tsx